export const FormMode = {
  View: 'view',
  New: 'new',
  Edit: 'edit',
} as const;

export type IFormMode = (typeof FormMode)[keyof typeof FormMode];
